import * as yup from 'yup'

const schema = (variables) => {
  const schemaByInputType = {
    text: yup.string().required(),
    number: yup.number().required(),
    date: yup.date().required().typeError('Precisa ser uma data válida'),
  }

  return yup.object().shape({
    ...variables.reduce(
      (acc, variable) => ({
        ...acc,
        [variable.inputName]: schemaByInputType[variable.variableType],
      }),
      {},
    ),
  })
}

export default schema
